import { SectionBox } from '@shared/components/ui/SectionBox';
import { faCalendar, faStore } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, AvatarFallback, AvatarImage } from '@shared/components/ui/shadcn/avatar';
import { formatDateWithTime } from '@shared/utils/FormatUtils';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface OrderInfoProps {
  orderCreatedAt?: string;
  shopName?: string;
  shopImageHash?: string;
}

export const OrderInfo: FC<OrderInfoProps> = ({ orderCreatedAt, shopName, shopImageHash }) => {
  const { t } = useTranslation('crmModule');

  const formattedDate = useMemo(() => {
    if (!orderCreatedAt) return 'N/A';
    return formatDateWithTime(orderCreatedAt);
  }, [orderCreatedAt]);

  return (
    <SectionBox className="bg-card-bg">
      <h2 className="text-lg font-bold">{t('details.orderInfo.title', 'Información del pedido')}</h2>
      <div className="space-y-4 pt-4">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 flex-shrink-0 rounded-full bg-hover-press flex items-center justify-center">
            <FontAwesomeIcon icon={faCalendar} className="text-icons !w-3 !h-3" />
          </div>
          <div>
            <p className="text-sm text-complementary-text">
              {t('details.orderInfo.creationDate', 'Fecha y hora de creación')}
            </p>
            <p className="text-sm font-medium">{formattedDate}</p>
          </div>
        </div>
        <div className="border-t border-card-border" />
        <div className="flex items-center gap-4">
          <Avatar className="h-10 w-10">
            <AvatarImage src={shopImageHash} alt={shopName || 'Shop'} />
            <AvatarFallback className="bg-white">
              <FontAwesomeIcon icon={faStore} className="!h-3 !w-3 text-success" />
            </AvatarFallback>
          </Avatar>
          <div>
            <p className="text-sm text-subtext">{t('details.orderInfo.shop', 'Tienda')}</p>
            <p className="font-medium">{shopName}</p>
          </div>
        </div>
      </div>
    </SectionBox>
  );
};
